<script>
  import Fa from "svelte-fa";
  import { createProduct, listProducts, products } from "./stores/products";
  import { faSave } from "@fortawesome/free-solid-svg-icons";
  import EditableField from "./EditableField.svelte";
  import { Product } from './proto/products_pb';
  import categories from './stores/categories.js';
  import { navigate } from 'svelte-routing';
  import { writable } from 'svelte/store';
  import { uploadImage as uploadImageGrpc } from "./stores/image_upload";
  import ChooseCategory from './ChooseCategory.svelte';

  let imagePreview = writable('');


  let product = new Product();

  $: imageUrl = product.getUrl();

  async function saveProduct() {
      const url = await uploadImage();
      product.setUrl(url);
      await createProduct(product);
      listProducts();
      console.log('Product created!');
      navigate('/');
  }
  /** @type {File | undefined} */
  let capturedFile;

  /**
   * Handles the image capture from an input event and sets the captured file.
   * @param {Event} event - The input event containing the file.
   */
  function handleImageCapture(event) {
    const file = event.target.files[0];
    if (file) {
      capturedFile = file; // Store the file for later upload
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.set(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  }

  /**
   * Handles the manual image upload from an input event and sets the captured file.
   * @param {Event} event - The input event containing the file.
   */
  function handleManualImageUpload(event) {
    const file = event.target.files[0];
    if (file) {
      capturedFile = file; // Store the file for later upload
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.set(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  }

  /**
   * Uploads the image file captured to the server.
   * @returns {Promise<string>} The URL of the uploaded image.
   */
  async function uploadImage() {
    if (capturedFile) {
      const result = await uploadImageGrpc(capturedFile);
      console.log(result);
      return result.getUrl();
      // Use your gRPC service to upload `capturedFile`
      // Example: await myGrpcService.uploadImage(capturedFile);
    } else {
      throw new Error('No file captured');
    }
  }
</script>


<div>
  <span class="font-bold text-lg">Създай продукт</span>
</div>
<div class="flex flex-col sm:flex-row mx-4">
  {#if $imagePreview}
    <img src={$imagePreview} alt="Preview" class="h-28 sm:h-28 md:h-36 lg:h-48 aspect-square object-contain inline-block rounded-l m-4 bg-gray-300" />
  {:else}
    <div class="h-28 md:h-28 aspect-square object-contain inline-block rounded-l m-4 bg-gray-300">
      <span class="text-xs sm:text-sm md:text-lg">Тук ще се покаже снимката</span>
    </div>
  {/if}
  <div class="w-8 md:w-20" />
  <div class="my-4 flex flex-col items-center">
    Цена:
    <EditableField 
      initialValue={product.getPrice().toFixed(2)}
      viewClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10 border-2 border-gray-300 rounded-lg"
      editClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10"
          validate={(value) => value.length > 0 && !isNaN(value)}
      on:update={(value) => product.setPrice(parseFloat(value.detail))}
    />
    Отстъпка:
    <EditableField 
      initialValue={product.getDiscountedprice().toFixed(2)}
      viewClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10 border-2 border-gray-300 rounded-lg text-red-500"
      editClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10 text-red-500"
          validate={(value) => value.length > 0 && !isNaN(value)}
      on:update={(value) => product.setDiscountedprice(parseFloat(value.detail))}
    />
    Име:
    <EditableField 
      initialValue={product.getName()}
      viewClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10 border-2 border-gray-300 rounded-lg"
      editClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10"
          validate={(value) => value.length > 0}
      on:update={(value) => product.setName(value.detail)}
    />
    Снимка: 
    <div class="my-4">
      <label for="cameraInput" class="cursor-pointer bg-blue-500 text-white p-2 rounded-lg">Снимай</label>
      <input type="file" id="cameraInput" accept="image/*" capture="environment" style="display: none;"
        on:change="{handleImageCapture}">
      
      <label for="manualUploadInput" class="cursor-pointer bg-green-500 text-white p-2 rounded-lg">Качи снимка</label>
      <input type="file" id="manualUploadInput" accept="image/*" style="display: none;" on:change="{handleManualImageUpload}">
    </div>
    Описание:
    <EditableField 
      initialValue={product.getDescription()}
      viewClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10 border-2 border-gray-300 rounded-lg"
      editClass="text-sm block w-48 sm:w-48 md:w-64 lg:w-96 h-10"
          validate={(value) => value.length > 0}
      on:update={(value) => product.setDescription(value.detail)}
      isTextarea={true}
    />
    Категория:
    <ChooseCategory setCategory={(selectedSubcategory) => product.setCategory(selectedSubcategory)}></ChooseCategory>


  </div>
  <div class="grow " />
  <div class="m-2 my-auto bg-blue-500 w-10 h-10 rounded-lg flex justify-center items-center cursor-pointer" on:click={saveProduct}>
    <Fa icon={faSave} size="1x" color="white" />
  </div>
</div>
<div class="py-4" />
